export const PORTFOLIO_DATA = {
  name: 'Akhil V J',
  email: 'akhilvj.creator@gmail.com',
  role: 'Full-Stack Developer & Odoo Specialist',
  description: "Hey, I'm Akhil — a self-driven developer, creative mind, and the kind of person who learns things before life forces it. I started with curiosity, but ended up falling deep into code — from building Odoo solutions and full-stack web apps to experimenting with automation and smart tech. I don't come from a fancy background. I come from grit, learning, and long nights turning ideas into something real. I've trained hard, built my own projects, and now I'm not waiting for opportunity — I'm designing it. Whether it's streamlining backends, building scalable systems, or turning scratch code into smooth experiences — I build what others scroll past. If you've seen the face — here's the mind behind it.",
  
  stats: [
    {
      number: '2+',
      label: 'Years of Experience',
      sublabel: 'In Development'
    },
    {
      number: '70+',
      label: 'Projects Completed',
      sublabel: 'This Year'
    },
    {
      number: '20+',
      label: 'Team Members',
      sublabel: 'Across 3 Countries'
    },
    {
      number: '15+',
      label: 'Technologies',
      sublabel: 'Mastered'
    }
  ],
  
  services: [
    {
      id: 1,
      title: 'Full-Stack Development',
      description: 'Building end-to-end web applications with modern frameworks, scalable architectures, and seamless user experiences.',
      icon: 'code',
      technologies: ['React', 'Django', 'Node.js', 'PostgreSQL']
    },
    {
      id: 2,
      title: 'Odoo ERP Solutions',
      description: 'Custom Odoo modules, business process automation, and enterprise resource planning implementations.',
      icon: 'hexagon',
      technologies: ['Python', 'Odoo', 'XML', 'JavaScript']
    },
    {
      id: 3,
      title: 'UI/UX Design',
      description: 'Creating intuitive, beautiful interfaces that enhance user experience and drive engagement.',
      icon: 'palette',
      technologies: ['Figma', 'Adobe XD', 'Photoshop', 'CSS3']
    },
    {
      id: 4,
      title: 'API Development',
      description: 'Designing and building robust RESTful APIs and GraphQL endpoints for scalable applications.',
      icon: 'smartphone',
      technologies: ['Django REST', 'Flask', 'FastAPI', 'GraphQL']
    }
  ],
  
  projects: [
    {
      id: 1,
      title: 'Shopping App',
      category: 'Full-Stack Development',
      image: null,
      description: 'Modern e-commerce solution with FastAPI backend, React frontend, real-time inventory management, and integrated payment systems.',
      liveUrl: 'https://qc-demo0.netlify.app/',
      technologies: ['FastAPI', 'React', 'PostgreSQL', 'Razorpay', 'Redis'],
      featured: true
    },
    {
      id: 2,
      title: 'Portfolio Website',
      category: 'UI/UX Design',
      image: null,
      description: 'Modern portfolio website showcasing my projects, skills, and experience with a clean and responsive design.',
      liveUrl: 'https://akhilvj.netlify.app',
      technologies: ['React', 'Node.js', 'CSS3', 'Framer Motion', 'Lucide Icons', 'AOS'],
      featured: false
    },
    {
      id: 3,
      title: 'Odoo CRM Customization',
      category: 'Odoo v17 Development',
      image: null,
      description: 'Custom Odoo CRM modules with advanced reporting, automated workflows, and third-party integrations for improved business processes.',
      liveUrl: null,
      githubUrl: 'https://github.com/akhil-vj/Library-Management-Odoo-v17',
      technologies: ['Python', 'Odoo', 'PostgreSQL', 'XML', 'JavaScript'],
      featured: true
    },
    {
      id: 4,
      title: 'Digital Voting System with OpenCV for Face Recognition',
      category: 'Full-Stack Development',
      image: null,
      description: 'Decentralized voting system with facial recognition for secure and transparent elections, built with Django and Opencv.',
      technologies: ['Django', 'OpenCV', 'HTML', 'CSS', 'PostgreSQL', 'Docker'],
      featured: false
    },
    {
      id: 5,
      title: 'Shopping App using Flask and React',
      category: 'Python Development',
      image: null,
      description: 'Modern e-commerce solution with Flask backend, React frontend, real-time inventory management, and integrated payment systems.',
      liveUrl: null,
      technologies: ['Python', 'Flask', 'PostgreSQL', 'React', 'Razorpay'],
      featured: false
    }
  ],
  
  skills: [
    // Backend Technologies
    'Python', 'Django', 'Flask', 'FastAPI', 'Node.js', 'Odoo',
    // Frontend Technologies
    'React', 'Next.js', 'TypeScript', 'JavaScript', 'HTML5', 'CSS3',
    // Databases
    'PostgreSQL', 'MongoDB', 'MySQL', 'Redis',
    // Tools & DevOps
    'Git', 'Docker', 'AWS', 'Vercel', 'Linux', 'Nginx',
    // Design & Other
    'Figma', 'Adobe XD', 'Photoshop', 'RESTful APIs', 'GraphQL', 'Web Scraping'
  ],
  
  experience: [
    {
      id: 1,
      company: 'Freelance Developer',
      position: 'Full-Stack Developer',
      duration: '2022 - Present',
      description: 'Developed custom web applications and Odoo ERP solutions for various clients. Specialized in Python backend development and React frontend applications.',
      technologies: ['Python', 'Django', 'React', 'Odoo', 'PostgreSQL']
    },
    {
      id: 2,
      company: 'Self-Learning Journey',
      position: 'Software Developer',
      duration: '2021 - 2022',
      description: 'Intensive self-learning period focusing on modern web technologies, data structures, algorithms, and building personal projects.',
      technologies: ['JavaScript', 'Python', 'React', 'Django', 'Git']
    }
  ],
  
  social: {
    github: 'https://github.com/akhil-vj',
    linkedin: 'https://linkedin.com/in/akhilvj210',
    twitter: 'https://twitter.com/akhilvj',
    instagram: 'https://instagram.com/akhil_v_j_'
  },
  
  contact: {
    email: 'akhilvj.creator@gmail.com',
    phone: '+91 9048464295',
    location: 'Kerala, India',
    availability: 'Available for freelance projects'
  }
};